import axiosInstance from "api/axios";
import { AdminLog } from "types/adminLog.type";

export const adminLogService = {
  getAll: async (
    page = 1,
    limit = 10,
    filters: Record<string, any> = {}
  ): Promise<{ logs: AdminLog[]; total: number }> => {
    const response = await axiosInstance.get("/admin-logs", {
      params: { page, limit, ...filters },
    });
    return response.data;
  },

  getById: async (id: number): Promise<AdminLog> => {
    const response = await axiosInstance.get(`/admin-logs/${id}`);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/admin-logs/${id}`);
  },
};
